import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { AmazingPanda_ResponsivePIXIApp } from "../AmazingPanda/game_ResponsivePIXIApp";

export class AmazingPandaLink_ResponsivePIXIApp extends AmazingPanda_ResponsivePIXIApp {
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "AmazingPandaLink");
        }
    }
